import { useMutation } from "@tanstack/react-query";
import { toast } from "react-hot-toast";

import { GetLiveKitTokenPayload, getLiveKitToken } from "../services/livekit";

export const useInitiateCall = () => {
  return useMutation({
    mutationFn: (payload: GetLiveKitTokenPayload) => getLiveKitToken(payload),
    onError: (error: { response?: { data?: { message?: string } } }) => {
      toast.error(error?.response?.data?.message || "Failed to initiate call");
    },
  });
};
